import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { SearchBarSize, SearchBarSubmitButtonColor } from '@/app/_components/searchbar/types';

type SearchBarSubmitButtonProps = {
  size?: SearchBarSize;
  submitLabel?: string;
  submitButtonColor?: SearchBarSubmitButtonColor;
  isLoading?: boolean;
};

export const SearchBarSubmitButton: React.FC<SearchBarSubmitButtonProps> = ({
  size = 'sm',
  submitLabel = 'Cerca',
  submitButtonColor = 'secondary',
  isLoading = false,
}) => (
  <div className={clsx('h-full w-full lg:w-auto', size === 'sm' && 'lg:p-1')}>
    <button
      type="submit"
      disabled={isLoading}
      aria-busy={isLoading}
      className={clsx(
        'flex h-full w-full flex-row items-center justify-center gap-3 rounded-full py-2 text-lg font-medium text-white transition-colors disabled:cursor-wait disabled:opacity-80 lg:text-xl lg:font-semibold',
        size === 'sm' && 'lg:aspect-square lg:py-0',
        size === 'lg' && 'lg:px-7 lg:py-3',
        submitButtonColor === 'primary' && 'bg-primary hover:bg-primary-hover',
        submitButtonColor === 'secondary' && 'bg-secondary hover:bg-secondary-hover',
      )}
    >
      {isLoading ? (
        <span className={clsx('size-5 animate-spin rounded-full border-2 border-white/40 border-t-white', size === 'lg' && 'lg:size-7')} />
      ) : (
        <MagnifyingGlassIcon className={clsx('size-5', size === 'lg' && 'lg:size-7')} />
      )}

      <span className={clsx(size === 'sm' && 'block lg:hidden')}>{submitLabel}</span>
    </button>
  </div>
);
